import { render, staticRenderFns } from "./FormilyTemplate-new.vue?vue&type=template&id=25e9ca02&scoped=true"
import script from "./FormilyTemplate-new.vue?vue&type=script&lang=js"
export * from "./FormilyTemplate-new.vue?vue&type=script&lang=js"
import style0 from "./FormilyTemplate-new.vue?vue&type=style&index=0&id=25e9ca02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e9ca02",
  null
  
)

export default component.exports